import React, { useState } from "react";
import { FiBookmark } from "react-icons/fi";
import MessageModal from "./MessageModal";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

const SocialMediaPost = ({
  userName,
  restaurantName,
  splDish,
  img,
  cost,
  rating,
  postId,
  onClick,
  profilePic,
}) => {
  const handleClick = () => {
    onClick(postId);
  };

  const token = localStorage.getItem("authToken");

  const [showModal, setShowModal] = useState(false);

  const [msg, setMsg] = useState("");

  const handleBookmarkClick = () => {
    const payload = {
      postID: postId,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, // Replace with your actual authentication token
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    };

    fetch("https://foodie-wirte.onrender.com/api/savedpost", requestOptions)
      .then((response) => response.json())
      .then((data) => {
        console.log("Bookmark saved:", data);
        if (data.message) {
          setMsg(data.message);
          setShowModal(true);
          setTimeout(() => {
            setShowModal(false);
          }, 2000);
        } else {
          setMsg("Post Saved");
          setShowModal(true);
          setTimeout(() => {
            setShowModal(false);
          }, 2000);
        }
      })
      .catch((error) => {
        console.error("Error saving bookmark:", error);
      });
  };

  const renderStars = () => {
    const starIcons = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        starIcons.push(
          <AiFillStar key={i} className="w-5 h-5 text-yellow-500" />
        );
      } else {
        starIcons.push(
          <AiOutlineStar key={i} className="w-5 h-5 text-yellow-500" />
        );
      }
    }
    return starIcons;
  };

  return (
    <div className="max-w-md bg-gray-100 rounded-md shadow-lg p-4 relative">
      <div className="flex items-center mb-3">
        <img
          src={profilePic}
          alt="User Profile"
          className="w-9 h-9 rounded-full mr-2"
        />
        <h3 className="text-gray-700 font-bold text-sm tracking-wide">
          {userName}
        </h3>
      </div>
      <div className="aspect-w-1 aspect-h-1">
        <img
          src={img}
          alt="Post"
          className="object-cover w-full rounded-md mb-2 shadow-lg"
          onClick={handleClick}
        />
      </div>
      <div className="flex justify-between">
        <div>
          <h4 className="text-gray-700 font-bold text-base my-1 tracking-wide">
            {splDish}
          </h4>
          <p className="text-gray-500 text-sm mb-1">{restaurantName}</p>
          <p className="text-red-600 font-bold text-base mb-1 tracking-wide">
            ₹{cost}
          </p>
          <div className="flex">{renderStars()}</div>
        </div>
        <div className="flex items-center">
          <FiBookmark
            className="w-6 h-6 text-gray-500 cursor-pointer"
            onClick={handleBookmarkClick}
          />
          {showModal && (
            <MessageModal message={msg ? msg : "Post Saved"} duration={2000} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SocialMediaPost;
